export default {
    common: {
        home: 'Home',
        o_nama: 'About us',
        usluge: 'Services',
        projekti: 'Projects',
        nas_tim: 'Our team',
        karijera: 'Career',
        contact: 'Contact',
        language: 'Language',
        yes: 'Yes',
        no: 'No',
        contact_message: 'You can contact us or visit us during business hours.',
        read_more: 'Read more',
    },

    footer: {
        description: 'A professional electrical company with many years of experience in providing high-quality electrical services for residential, commercial and industrial facilities.',
        contact_info: 'Contact information',
        location: 'Slovenia / Europe',
        rights: 'All rights reserved.',
        email_subject: 'Inquiry via website',
        email_body: 'Hello,\n\nPlease send me more information.',
    },

    slogans: {
        prvi_slajd: 'MAMONT - The power of reliability, expertise without limits!',
        drugi_slajd: 'Innovative solutions for every electrical challenge.',
        treci_slajd: 'MAMONT – Building the future, cable by cable.',
    },

    homepage: {
        hero_eyebrow: 'Electrical installation • Industry • Energy',
        hero_text: 'Reliable electrical installation solutions for industrial, commercial and technically demanding projects across Europe.',
        pogledaj_usluge: 'View services',
        prijavi_se: 'Apply for a job',

        zadovoljnih_klijenata: 'Satisfied clients',
        projekata: 'Projects',
        zaposlenih: 'Employees',

        why_eyebrow: 'Why choose us',
        zasto_mamont: 'Why MAMONT?',
        why_description: 'We combine experience, skilled workers and a responsible approach to deliver every project with quality, safety and respect for agreed deadlines.',

        reason_1_title: 'Reliability',
        zato_sto: 'Because we approach every project responsibly and precisely.',
        reason_2_title: 'Loyalty',
        lojalnost: 'We build long-term relationships with clients and partners.',
        reason_3_title: 'Experience',
        iskustvo: 'Our team has experience in demanding electrical installation projects.',
        reason_4_title: 'Skilled workforce',
        visokokvalifikovani_radnici: 'We have highly qualified workers ready for serious projects.',

        project_eyebrow: 'Field work',
        svaki_projekat: 'Every project requires responsibility, precision and a team you can trust.',
        pogledaj_projekte: 'View projects',

        team_eyebrow: 'Our team',
        mamont_tim_u_akciji: 'Mamont team in action',
        za_nas: 'For us, every project is a responsibility towards the client, the team and the standard we build.',
        upoznaj_tim: 'Meet the team',

        klijenti_od_povjerenja: 'Trusted clients',
        partneri: 'Our partners',
        sa_zadovoljstvom: 'We are proud to highlight partners and clients who have placed their trust in us.',
    },

    about_us: {
        hero_title: 'A reliable partner for projects across Europe',

        mi_smo_kompanija_mamont: 'We are MAMONT d.o.o., a synonym for quality, reliability and innovation in the field of electrical installations.',
        ko_smo_mi: 'Who we are',
        firma_sa_iskustvom: 'A company with many years of experience and dedication to quality, based in Slovenia. We provide our services to clients across Europe, including Germany, Belgium, the Netherlands and Italy. Our long-standing tradition and experience in delivering demanding projects make us a reliable partner in all aspects of electrical installations.',

        feature_1_title: 'Electrical installation',
        feature_1_text: 'Execution of electrical installations and system assembly for industrial and commercial facilities.',
        feature_2_title: 'Reliable partner',
        feature_2_text: 'Long-term cooperation with clients based on trust and quality.',
        feature_3_title: 'Expert team',
        feature_3_text: 'Experienced workers ready to work on demanding projects across Europe.',

        projects_across_europe: 'Projects across Europe',

        misija: 'Mission',
        nasa_misija: 'Our mission is simple — to provide comprehensive, efficient and innovative solutions that meet and exceed our clients’ expectations.',
        strpljiv_pristup: 'Through a patient approach, dedication to quality and a team of highly qualified professionals, we build long-term relationships with our partners.',

        values_eyebrow: 'Our values',
        values_title: 'Values that guide us',
        values_description: 'In every project, we follow the same principles: responsibility, safety, precision and respect for agreed deadlines.',

        value_1_title: 'Safety',
        value_1_text: 'The safety of workers, clients and facilities is always a priority.',
        value_2_title: 'Innovation',
        value_2_text: 'We apply modern solutions and efficient work methods.',
        value_3_title: 'Quality',
        value_3_text: 'Every detail must be executed professionally and precisely.',
        value_4_title: 'Responsibility',
        value_4_text: 'We respect agreed deadlines, standards and client needs.',
    },

    services: {
        nase_usluge: 'Our services',
        hero_title: 'Electrical installation solutions for serious projects',
        navescemo_usluge: 'Below we highlight the key services Mamont provides through an expert team, experience and work on demanding projects across Europe.',
        posalji_upit: 'Send inquiry',

        what_we_do: 'What we do',
        services_description: 'From cable laying and cable tray installation to system testing — we focus on quality, safety and precise execution.',

        service_tag_1: 'Electrical installation',
        pruzanje_kablova: 'Cable laying',
        pruzanje_kablova_nacin: 'Professional cable laying with route planning, precise work organization and respect for technical standards.',

        service_tag_2: 'Quality control',
        testiranje_sistema: 'System testing',
        oprema_za_testiranje: 'Use of appropriate equipment for inspection, testing and quality control of completed electrical systems.',

        service_tag_3: 'Installations',
        instalacija_kanalica: 'Cable tray installation',
        instalacija_kanalica_text: 'Installation of electrical cable trays and cable routes for industrial, commercial and technically demanding facilities.',

        zatrazi_ponudu: 'Request an offer',

        process_eyebrow: 'Work process',
        process_title: 'From agreement to execution — clear, precise and responsible.',
        process_text: 'We approach every project through planning, team organization, field safety and final execution quality.',

        step_1_title: 'Project analysis',
        step_1_text: 'We understand the client’s needs, scope of work and technical project requirements.',
        step_2_title: 'Team organization',
        step_2_text: 'We plan people, equipment, work dynamics and safety procedures.',
        step_3_title: 'Field execution',
        step_3_text: 'We work precisely, responsibly and in accordance with agreed deadlines.',

        cta_eyebrow: 'Need a reliable team?',
        cta_title: 'Let’s talk about your project.',
        cta_text: 'Send us an inquiry and we will contact you with cooperation information.',
        kontaktirajte_nas: 'Contact us',

        email_subject: 'Inquiry for Mamont services',
        email_body: 'Hello,\n\nPlease send me more information about your services.',
    },

    projects: {
        nasi_projekti: 'Our projects',
        hero_title: 'Projects delivered with precision, responsibility and experience',
        nasa_firma: 'Our company participates in the realization of electrical installation projects for industrial and commercial facilities across Europe.',

        gallery_eyebrow: 'Work gallery',
        featured_projects: 'Featured projects',
        gallery_description: 'Take a look at part of the field atmosphere, works and projects in which the Mamont team participated.',
        gallery_items: 'Photos',
        region: 'Region',

        project_1_title: 'Industrial electrical installations',
        project_1_text: 'Electrical installation and assembly works for industrial and commercial facilities.',

        project_2_title: 'Cable route installation',
        project_2_text: 'Organized execution of cable routes, cable trays and related electrical infrastructure.',

        project_3_title: 'Field work',
        project_3_text: 'Mamont team on demanding projects with a focus on safety, quality and deadlines.',

        project_4_title: 'Electrical installation projects',
        project_4_text: 'Execution of works for clients through precise organization and an expert team.',

        project_5_title: 'Technical execution',
        project_5_text: 'Works on systems and installations that require experience and responsibility.',

        project_6_title: 'Projects across Europe',
        project_6_text: 'Experience in project realization in Slovenia and across the European market.',

        project_7_title: 'Installations and assembly',
        project_7_text: 'Reliable execution of electrical works for different types of facilities.',

        project_8_title: 'Mamont team',
        project_8_text: 'Skilled workers, teamwork and field organization.',

        project_9_title: 'Quality execution',
        project_9_text: 'We carry out every project with attention to detail and technical standards.',

        project_10_title: 'Electrical systems',
        project_10_text: 'Works on electrical systems and related installations.',

        project_11_title: 'Professional assembly',
        project_11_text: 'Reliable assembly and execution of works in accordance with project requirements.',

        project_12_title: 'Field operations',
        project_12_text: 'Practical project execution with experience and responsible organization.',

        project_13_title: 'Cable tray installation',
        project_13_text: 'Installation of cable trays and cable systems for industrial facilities.',

        project_14_title: 'Industrial facilities',
        project_14_text: 'Works in industrial environments with special technical requirements.',

        project_15_title: 'Electrical equipment',
        project_15_text: 'Work with electrical equipment and installations on projects of various scopes.',

        project_16_title: 'Project realization',
        project_16_text: 'From planning to final execution, the focus remains on quality and safety.',

        project_17_title: 'Complex works',
        project_17_text: 'Execution of demanding electrical installation works with an expert team.',

        project_18_title: 'Mamont projects',
        project_18_text: 'Part of our completed works and field experience.',
    },

    tim: {
        stranica_u_pripremi: 'Page is under construction',
        molimo_vas: 'Please check again later. Your MAMONT',
    },

    career: {
        hero_eyebrow: 'Career',
        hero_title: 'Become part of the Mamont team',
        hero_subtitle: 'Work on major projects across Europe',
        hero_button: 'Send application',

        intro_eyebrow: 'Open applications',
        intro_title: 'We are looking for responsible electrical installers and workers ready for field work.',
        intro_text: 'If you have experience in electrical installation, cable routes, installation work, or if you are ready to learn and work in a serious team, send us your application.',

        benefits: {
            projects: {
                title: 'Major projects',
                text: 'Work on serious electrical installation projects across Europe.',
            },
            team: {
                title: 'Stable team',
                text: 'Organized work, clear communication and support in the field.',
            },
            growth: {
                title: 'Professional growth',
                text: 'Opportunity for advancement, learning and long-term cooperation.',
            },
        },

        form_eyebrow: 'Job application',
        form_title: 'Send your details',
        form_description_no_upload: 'Fill out the form and optionally add a link to your CV or document. Our team will review your application and contact you if there is a suitable position.',

        note_title: 'Note',
        note_text: 'Fields marked with an asterisk are required.',

        email: {
            subject: 'New job application - Mamont',
        },

        fields: {
            full_name: 'Full name',
            email: 'Email address',
            phone: 'Phone',
            location: 'Place of residence',
            position: 'Position you are applying for',
            experience: 'Years of experience',
            availability: 'Availability to start work',
            eu_citizen: 'Are you an EU citizen',
            eu_citizen_confirm: 'Yes, I am an EU citizen',
            message: 'Work experience / short message',
            cv_upload: 'CV / document',
            privacy_consent: 'I agree that Mamont may process my data for the purpose of my job application.',
        },

        placeholders: {
            full_name: 'Enter your full name',
            email: "name{'@'}email.com",
            phone: '+387 / +386 / +49',
            location: 'City / country',
            position: 'Select a position',
            experience: 'Select experience',
            availability: 'Immediately / in 15 days / by agreement',
            message: 'Briefly describe your experience, skills and availability for work.',
        },

        positions: {
            electro_installer: 'Electrical installer',
            assistant_worker: 'Assistant worker',
            team_lead: 'Team leader / foreman',
            other: 'Other',
        },

        experience: {
            no_experience: 'No experience',
            one_two: '1–2 years',
            three_five: '3–5 years',
            five_plus: '5+ years',
        },

        file: {
            empty: 'Add a PDF, DOC or DOCX document',
            limit: 'The maximum document size is 10 MB.',
        },

        submit: {
            default: 'Send application',
            loading: 'Sending...',
        },

        success: 'Your application has been sent successfully. Thank you for your interest.',

        errors: {
            file_type: 'Only PDF, DOC and DOCX documents are allowed.',
            file_size: 'The document must not be larger than 10 MB.',
            privacy_required: 'You must confirm consent for data processing.',
            generic: 'An error occurred. Please try again.',
        },
    },
};